"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Container = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-1y4l1nb-0"
})(["", ";@media (max-width:", "){padding-inline:", ";}@media (min-width:", "){padding-inline:", ";}"], (0, _index.rootStyle)(), _encoreFoundation.screenXsMax, (0, _index.cssLayoutMargin)('base', '24px'), _encoreFoundation.screenSmMin, (0, _index.cssLayoutMargin)('base', '32px'));
var _default = exports["default"] = Container;